export enum Currency {
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
}
